import { captureMessage } from 'lib/reporting';

const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      return document.execCommand('copy', true, text);
    }
  } catch (e) {
    captureMessage('Copying to clipboard was unsuccessful', 'warning', {
      error: e,
    });

    return false;
  }
};

export default copyToClipboard;
